// Internal — shared id-parse machinery for every BC's `id.ts`.
//
// Not exported from `src/index.ts`. The leading underscore marks the
// directory as internal-only; only per-BC id modules import from here.
//
// Every branded id in @bilda/core shares:
//   - `isSafeId` — the floor predicate every `to` uses.
//   - `mkParser`  — folds `brand` + `mk` into a `Result`-returning `to`.
//
// Duplicating either per BC would drift. Keeping them here lets each
// per-BC `id.ts` stay a five-line file that reads at a glance.
export { isSafeId, mkParser };
import { Result } from "@bilda/utils";
import * as IdError from "../idError.js";
// === Shared parse predicate ===
//
// MVP: a "safe id" is a non-empty printable string with no leading /
// trailing whitespace and no control characters. The shell generates
// ids (UUIDs, ULIDs, opaque tokens); this predicate is a floor, not a
// full URL-safe scheme. Individual BCs can layer stricter rules on top
// later (e.g. Format's `formatXxx` naming) — this catches the obvious
// footguns.
const isSafeId = (s) => {
    if (s.length === 0) {
        return false;
    }
    if (s !== s.trim()) {
        return false;
    }
    // Reject control chars (U+0000..U+001F and U+007F).
    for (let i = 0; i < s.length; i++) {
        const code = s.charCodeAt(i);
        if (code < 0x20 || code === 0x7f) {
            return false;
        }
    }
    return true;
};
const mkParser = (brand, mk) => {
    return (s) => isSafeId(s)
        ? Result.ok(mk(s))
        : Result.err(IdError.mkMalformed(brand, s));
};
//# sourceMappingURL=parse.js.map